<div class="d-flex my-4 overflow-x-auto">
  @for (btn of buttons(); track $index) {
  <button role="button" class="btn rounded-5 m-1 text-nowrap font-bold py-1 px-2"
    [class.btn-cfPrimary]="selectedBtnKey() === btn.key" [class.unselected-btn]="selectedBtnKey() !== btn.key"
    (click)="changeSelectedButton(btn.key)">
    {{ btn.label }}
  </button>
  }
</div>